import { ReportsInventoryAPIMethods, ReportsInventoryLabelName, ReportsInventoryNames, ReportsInventoryRoutes } from '../../models/reports-inventory.models';
import { MessageService } from 'primeng/api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppMainService } from '../../../app-main.service';
import { AppMainComponent } from '../../../app.main.component';
import { ReportService } from '../../reportService';
import { IReportsColumnModel } from '../../models/reports.models';
import { IReportsFilterModel } from '../../models/reports-filter.models';
import { ParseHelper } from '../../../modules/shared/parse.helper';
// import { LocalDatePipe } from 'src/app/shared/pipes/local-date.pipe';
import { LocalDatePipe } from '../../../modules/shared/pipes/local-date.pipe';
import { DataService } from '../../dataService';
import { IReportsDataServiceLeftMenuExpantionModel, IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues } from '../../models/reports-data-service-model';
import { takeUntil } from 'rxjs/operators';
import { ReportsExportExcelService } from '../../servies/reports-export-excel.service';
import { ReportsPrintPdfService } from '../../servies/reports-print-pdf.service';
import { DatePipe } from '@angular/common';
import { TimeConvertPipe } from '../../../modules/shared/pipes/timeConvert.pipe';
import { CurrencySymbolPipe } from '../../../modules/shared/pipes/currency-symbol.pipe';
import { PercentageSymbolPipe } from '../../../modules/shared/pipes/percentage-symbol.pipe';
import { DateRangeFilterService } from 'src/app/modules/shared/services/date-range-filter.service';
import { DateFilterType } from 'src/app/models/date-range/get-date-range.models';
@Component({
    selector: 'app-reports-inventory',
    templateUrl: './reports-inventory.component.html',
    styleUrls: ['./reports-inventory.component.scss'],
    providers: [LocalDatePipe, CurrencySymbolPipe, PercentageSymbolPipe]
})
export class ReportsInventoryComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    //#region Properties
    public selectedWindow: string = '';
    public reportName: string = '';
    public dateFrom: any = new Date();
    public dateTo: any = new Date();
    public reportDate: any;
    public filterType;
    public apiName;
    public showInActive: boolean = false;//active/inactive for inventory valuation

    public cols: IReportsColumnModel[] = [];
    // public filteredCols: IReportsColumnModel[] = [];
    public detailsCols: IReportsColumnModel[] = [];
    public reportDatas: any[] = [];
    public reportDatasCopy = [];
    public reportRowDetails = [];
    public filterByInputValue: any[] = [];
    public totalRecords: number;
    public totalPages: number;
    public results: any[] = [];
    public IsShowReportTemplate: boolean = true;
    public noContactFindOrLoadingText = 'Loading....';
    public organizationName = "";
    public detailsHeader = "";
    public detailsHeaderTitle = "";
    public detailsGroupTypeColName = "";
    public groupTypeColName
    public showTotal: boolean;

    ReportsInventoryNames = ReportsInventoryNames;
    accountsChannelList: any[] = [];
    showChannelFilter: boolean = false;
    channelList: any[] = [];
    selectedChannel;
    showWarehouseLocationFilter: boolean = false;
    warehouseLocationList: any[] = [];
    selectedWarehouseLocation;
    reportTotalRow: {} = {};
    reportDetailsTotalRow: {} = {};
    findDiscountRow: any;
    groupWiseReportTotalRow: any;
    selectedFilterVm: IReportsFilterModel[];
    //#endregion
    constructor(private app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private router: ActivatedRoute,
        private messageService: MessageService,
        public localDatePipe: LocalDatePipe,
        private dataService: DataService,
        // public datePipe: DatePipe,
        private timeConvertPipe: TimeConvertPipe,
        private currencySymbolPipe: CurrencySymbolPipe,
        private percentageSymbolPipe: PercentageSymbolPipe
    ) {
        //set timezone date
        this.dateFrom = this.app._showDateTimeWithZone(new Date());
        this.dateTo = this.app._showDateTimeWithZone(new Date());
        //*************Pring & Export(PDF/Excel)****************
        this.dataService.getData<IReportsDataServiceTopMenuModel>().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data.actionType == ReportsDataServiceModelValues.reportsTopMenuItems) {
                if (data.value == ReportsTopMenuItemsValues.print) {
                    this.print();
                }
                else if (data.value == ReportsTopMenuItemsValues.PDF) {
                    this.exportPDF(this.selectedWindow, false);
                }
                else if (data.value == ReportsTopMenuItemsValues.XLS) {
                    this.exportXLS(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.XLSX) {
                    this.exportXLSX(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.Refresh) {
                    this.cols = [];
                    this.getInventoryReportData();
                }
            }
        });
    }

    async ngOnInit() {
        this.accountsChannelList = await this.dataService.getAccountChannelList();
        this.warehouseLocationList = await this.dataService.getAllWarehouse();
        this.organizationName = this.app.user.organizationName;
        this.router.paramMap.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((param: any) => {
            this.appMainService.isHideSpinner(this.reportName);
            const activityType = param.params.type;
            this.showChannelFilter = false;
            this.channelList = [];
            this.selectedChannel = null;
            this.showWarehouseLocationFilter = false;
            // this.warehouseLocationList = [];
            this.selectedWarehouseLocation = null;
            this.cols = [];
            // this.filteredCols = [];
            this.reportDatas = [];
            this.reportDatasCopy = [];
            switch (activityType) {
                case ReportsInventoryRoutes.accountsReceivable:
                    this.selectedWindow = ReportsInventoryNames.accountsReceivable;
                    this.reportName = ReportsInventoryLabelName.accountsReceivable;
                    break;
                case ReportsInventoryRoutes.inventoryValuationSummary:
                    this.selectedWindow = ReportsInventoryNames.inventoryValuationSummary;
                    this.reportName = ReportsInventoryLabelName.inventoryValuationSummary;
                    break;
                case ReportsInventoryRoutes.inventoryValuationDetail:
                    this.selectedWindow = ReportsInventoryNames.inventoryValuationDetail;
                    this.reportName = ReportsInventoryLabelName.inventoryValuationDetail;
                    break;
                case ReportsInventoryRoutes.inventorySnapshot:
                    this.selectedWindow = ReportsInventoryNames.inventorySnapshot;
                    this.reportName = ReportsInventoryLabelName.inventorySnapshot;
                    break;
                case ReportsInventoryRoutes.profitability:
                    this.selectedWindow = ReportsInventoryNames.profitability;
                    this.reportName = ReportsInventoryLabelName.profitability;
                    break;
                case ReportsInventoryRoutes.inventoryopeninvoice:
                    this.selectedWindow = ReportsInventoryNames.inventoryopeninvoice;
                    this.reportName = ReportsInventoryLabelName.inventoryopeninvoice;
                    break;
                case ReportsInventoryRoutes.inventoryallinvoice:
                    this.selectedWindow = ReportsInventoryNames.inventoryallinvoice;
                    this.reportName = ReportsInventoryLabelName.inventoryallinvoice;
                    break;
                case ReportsInventoryRoutes.invoiceByRep:
                    this.selectedWindow = ReportsInventoryNames.invoiceByRep;
                    this.reportName = ReportsInventoryLabelName.invoiceByRep;
                    break;
                case ReportsInventoryRoutes.invoiceByCustomer:
                    this.selectedWindow = ReportsInventoryNames.invoiceByCustomer;
                    this.reportName = ReportsInventoryLabelName.invoiceByCustomer;
                    break;
                case ReportsInventoryRoutes.profitByRep:
                    this.selectedWindow = ReportsInventoryNames.profitByRep;
                    this.reportName = ReportsInventoryLabelName.profitByRep;
                    break;
                case ReportsInventoryRoutes.profitByCustomer:
                    this.selectedWindow = ReportsInventoryNames.profitByCustomer;
                    this.reportName = ReportsInventoryLabelName.profitByCustomer;
                    break;
                case ReportsInventoryRoutes.shipping:
                    this.selectedWindow = ReportsInventoryNames.shipping;
                    this.reportName = ReportsInventoryLabelName.shipping;
                    break;
                case ReportsInventoryRoutes.openSalesOrders:
                    this.selectedWindow = ReportsInventoryNames.openSalesOrders;
                    this.reportName = ReportsInventoryLabelName.openSalesOrders;
                    break;
                case ReportsInventoryRoutes.backSalesOrders:
                    this.selectedWindow = ReportsInventoryNames.backSalesOrders;
                    this.reportName = ReportsInventoryLabelName.backSalesOrders;
                    break;
                case ReportsInventoryRoutes.salesOrderCommited:
                    this.selectedWindow = ReportsInventoryNames.salesOrderCommited;
                    this.reportName = ReportsInventoryLabelName.salesOrderCommited;
                    break;
                case ReportsInventoryRoutes.picktimebypicker:
                    this.selectedWindow = ReportsInventoryNames.picktimebypicker;
                    this.reportName = ReportsInventoryLabelName.picktimebypicker;
                    break;
                case ReportsInventoryRoutes.picktimebylocation:
                    this.selectedWindow = ReportsInventoryNames.picktimebylocation;
                    this.reportName = ReportsInventoryLabelName.picktimebylocation;
                    break;
                case ReportsInventoryRoutes.packtimebypacker:
                    this.selectedWindow = ReportsInventoryNames.packtimebypacker;
                    this.reportName = ReportsInventoryLabelName.packtimebypacker;
                    break;
                case ReportsInventoryRoutes.packtimebylocation:
                    this.selectedWindow = ReportsInventoryNames.packtimebylocation;
                    this.reportName = ReportsInventoryLabelName.packtimebylocation;
                    break;
                case ReportsInventoryRoutes.accountsPayable:
                    this.selectedWindow = ReportsInventoryNames.accountsPayable;
                    this.reportName = ReportsInventoryLabelName.accountsPayable;
                    break;
                case ReportsInventoryRoutes.inventoryAging:
                    this.selectedWindow = ReportsInventoryNames.inventoryAging;
                    this.reportName = ReportsInventoryLabelName.inventoryAging;
                    break;
                case ReportsInventoryRoutes.incomeCutomerDetail:
                    this.selectedWindow = "incomeCutomerDetail";
                    break;
                case ReportsInventoryRoutes.incomeCutomerSummary:
                    this.selectedWindow = "incomeCutomerSummary";
                    break;
                case ReportsInventoryRoutes.expensesVendorDetail:
                    this.selectedWindow = "expensesVendorDetail";
                    break;
                case ReportsInventoryRoutes.expensesVendorSummary:
                    this.selectedWindow = "expensesVendorSummary";
                    break;
                default:
                    break;
            }
            //this.setFilterCols();
            //Send To Parent Component For Left Menu Expand
            this.dataService.sendData<IReportsDataServiceLeftMenuExpantionModel>({ actionType: ReportsDataServiceModelValues.reportsLeftMenuExpansion, value: this.selectedWindow });

            //Get Report  data
            this.getInventoryReportData();

        });
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    getAllAgingReorts(apiMethodName: string, selectedObjId: number = 0): void {
        this.appMainService.isShowSpinner(this.reportName);
        const filter = this.filterType.code == "custom" ? "Custom" : "AsOfDate";
        this.reportService.allAgingReorts(this.formatDate(this.dateFrom ?? this.dateTo), this.formatDate(this.dateTo), filter).then(resp => {
            this.appMainService.isHideSpinner(this.reportName);
            this.reportDatas = resp.reports;
            this.setFilterValues(this.reportDatas);
        })
        this.cols = [
            { id: 1, field: 'itemNo', header: 'Item No', dataType: 'string' },
            { id: 2, field: 'qoh', header: 'QOH', dataType: 'number' },
            { id: 3, field: 'atp', header: 'ATP', dataType: 'number' },
            { id: 4, field: 'lastSaleDate', header: 'Last Inv. Date', dataType: 'date' },
            { id: 5, field: 'invNo', header: 'Inv. No.', dataType: 'string' },
            { id: 6, field: 'salesPrice', header: 'Sales Price', dataType: 'currencySymbol' },
            { id: 7, field: 'aging', header: 'Aging (Days)', dataType: 'number' },
            { id: 8, field: 'warehouseName', header: 'Loc.', dataType: 'string' },
        ]
    }
    GetFilterAgingReport(selectedItem) {
        const filter = this.filterType.code == "Custom" ? "Custom" : "AsOfDate";
        let data = { FromDate: this.formatDate(this.dateFrom ?? this.dateTo), Todate: this.formatDate(this.dateTo), datefiltertype: filter, filters: selectedItem }
        this.reportService.allAgingFilterReorts(data).then(resp => {
            this.reportDatas = (resp);
            this.setFilterValues(this.reportDatas);
        })
    }


    getAllInventoryReports(apiMethodName: string, selectedObjId: number = 0): void {
        let fromDate = this.formatDate(this.dateFrom ?? this.dateTo);
        let toDate = this.formatDate(this.dateTo);
        let filter = null;
        if ((this.filterType.code == 'Custom' || this.filterType.code == 'custom') &&
            (apiMethodName == "InventoryCustomers"
                || apiMethodName == "AccountsReceivableDetail"
                || apiMethodName == "InventoryVendor"
                || apiMethodName == "AccountsPayableDetail"
            )) {
            filter = DateFilterType.asOfDate;
        } else {
            filter = null
        }
        if (apiMethodName == ReportsInventoryAPIMethods.InventoryInvoice
            || apiMethodName == ReportsInventoryAPIMethods.InventoryCustomers
            || apiMethodName == ReportsInventoryAPIMethods.InventoryVendor) {
            fromDate = this.formatDateUTC(this.dateFrom ?? this.dateTo);
            toDate = this.formatDateUTC(this.dateTo, true);
        }
        this.reportDatas = [];
        this.appMainService.isShowSpinner(this.reportName);
        this.reportService.allInventoryReports(this.selectedWindow,
            this.selectedChannel?.id ?? 0,
            fromDate,
            toDate,
            apiMethodName,
            filter).then(
                (res) => {
                    this.appMainService.isHideSpinner(this.reportName);
                    let { reports } = res;
                    this.reportDatas = reports;
                    this.reportDatasCopy = ParseHelper.DeepCopy(reports);
                    if (this.selectedWindow == ReportsInventoryNames.profitByRep || this.selectedWindow == ReportsInventoryNames.profitByCustomer) {
                        this.findDiscountRow = this.reportDatas.find(x => x.row_discount > 0);
                    }
                    this.setFilterCols();
                    //set filter value
                    //this.setFilterValues(this.reportDatas);
                    (err: any) => {
                        this.appMainService.isHideSpinner(this.reportName);
                    }
                });
    }
    getInventoryValuationReports(apiMethodName: string, applyFilter: boolean = false): void {
        this.appMainService.isShowSpinner(this.reportName);
        this.reportDatas = [];
        this.reportService.getInventoryValuationReports(this.selectedWindow,
            this.selectedChannel?.id ?? 0,
            this.selectedWarehouseLocation?.id ?? 0,
            this.showInActive,
            this.formatDate(this.dateFrom ?? this.dateTo),
            this.formatDate(this.dateTo),
            apiMethodName).then(
                (res) => {
                    this.appMainService.isHideSpinner(this.reportName);
                    let { reports } = res;
                    this.reportDatas = reports;
                    this.reportDatasCopy = ParseHelper.DeepCopy(reports);;
                    this.setFilterCols();
                    if (applyFilter) {
                        this.onApplyFilter(this.selectedWindow, this.selectedFilterVm);
                    }
                    //set filter value
                    //this.setFilterValues(this.reportDatas);

                }, (err: any) => {
                    this.appMainService.isHideSpinner(this.reportName);
                    this.setFilterValues(this.reportDatas);
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.status == 400 ? err?.statusText : 'No Data Found...' });
                });
    }

    //get table row details
    getReportRowDetails(reportType: string, channelId: number, apiMethodName: string, idPart: string): void {
        let filter = null;
        let fromDate = this.formatDate(this.dateFrom ?? this.dateTo);
        let toDate = this.formatDate(this.dateTo);
        if ((this.filterType.code == 'Custom' || this.filterType.code == 'custom') &&
            (apiMethodName == "InventoryCustomers"
                || apiMethodName == "AccountsReceivableDetail"
                || apiMethodName == "InventoryVendor"
                || apiMethodName == "AccountsPayableDetail"
            )) {
            filter = DateFilterType.asOfDate;
        } else {
            filter = null
        }
        if (apiMethodName == ReportsInventoryAPIMethods.AccountsReceivableDetail
            || apiMethodName == ReportsInventoryAPIMethods.AccountsPayableDetail) {
            fromDate = this.formatDateUTC(this.dateFrom ?? this.dateTo);
            toDate = this.formatDateUTC(this.dateTo, true);
        }
        this.reportService.allInventoryReportsDetails(reportType,
            channelId,
            idPart,
            fromDate,
            toDate,
            apiMethodName,
            filter).then(
                (res) => {
                    this.appMainService.isHideSpinner(this.reportName);
                    let { reports } = res;
                    this.reportRowDetails = reports;
                    //this.reportRowDetails = this.reportRowDetails?.sort((a, b) => (a[detailsGroupTypeColName] > b[detailsGroupTypeColName]) ? -1 : 1);
                    (err: any) => {
                        this.appMainService.isHideSpinner(this.reportName);
                    }
                });

    }

    private formatDateUTC(date: Date, isEndDate: boolean = false): any {
        const originalDate = new Date(moment(date).format('MM-DD-YYYY'));
        const gmtOffset = this.app.getUserGMT() ?? 'GMT+00:00';
        let adjustedDate = this.getUtcDateFromTimezone(originalDate, gmtOffset);
        if (isEndDate) {
            adjustedDate = moment(adjustedDate).add(23, 'hours').add(59, 'minutes').add(59, 'seconds').add(999, 'milliseconds').toDate();
        }
        return adjustedDate;
    }

    private formatDate(date: Date): any {
        let utcDate = date;
        utcDate = this.app._saveDateTimeWithZone(this.app._showDateTimeWithZone(date)) ?? date;
        if (this.filterType?.code == "Custom") {
            utcDate = this.app._saveDateTimeWithZone(moment(date).format('MM-DD-YYYY')) ?? date;
        }
        else {
            utcDate = this.app._saveDateTimeWithZone(moment(date).format('MM-DD-YYYY')) ?? date;
        }
        return moment(utcDate).format('MM-DD-YYYY');
    }

    getUtcDateFromTimezone(localDate: Date, gmtOffset: string): Date {
        const offsetMatch = gmtOffset.match(/GMT([+-])(\d{2}):(\d{2})/);

        if (!offsetMatch) {
            throw new Error("Invalid GMT offset format. Expected format: 'GMT+HH:mm' or 'GMT-HH:mm'");
        }

        const sign = offsetMatch[1] === "+" ? 1 : -1; // Determine if the offset is positive or negative
        const hours = parseInt(offsetMatch[2], 10); // Extract hours
        const minutes = parseInt(offsetMatch[3], 10); // Extract minutes

        // Calculate the total offset in milliseconds
        const offsetMilliseconds = sign * (hours * 60 * 60 * 1000 + minutes * 60 * 1000);
        const utcDate: Date = new Date(JSON.parse(JSON.stringify(localDate)));
        const localOffset = utcDate.getTimezoneOffset() * 60 * 1000;
        // Subtract the offset to get UTC date
        return new Date(utcDate.getTime() - offsetMilliseconds - localOffset);
    }

    getInventoryReportData(applyFilter: boolean = false) {
        switch (this.selectedWindow) {
            case ReportsInventoryNames.accountsReceivable:
                this.apiName = ReportsInventoryAPIMethods.InventoryCustomers;
                this.getAllInventoryReports(ReportsInventoryAPIMethods.InventoryCustomers);
                break;
            case ReportsInventoryNames.inventoryAging:
                this.apiName = ReportsInventoryAPIMethods.inventoryAging;
                this.reportName = "Inventory Aging Report";
                this.reportDate = new Date();
                this.getAllAgingReorts(ReportsInventoryAPIMethods.inventoryAging);
                break;
            case ReportsInventoryNames.inventoryValuationDetail:
                this.apiName = "";
                this.showWarehouseLocationFilter = true;
                this.addRemoveAllWarehouseOption('remove');
                this.selectedWarehouseLocation = this.warehouseLocationList ? this.selectedWarehouseLocation || this.warehouseLocationList[0] : null;
                this.getInventoryValuationReports(ReportsInventoryAPIMethods.Inventory);
                break;
            case ReportsInventoryNames.inventoryValuationSummary:
                this.apiName = "";
                this.showWarehouseLocationFilter = true;
                this.addRemoveAllWarehouseOption('add');
                this.selectedWarehouseLocation = this.warehouseLocationList ? this.selectedWarehouseLocation || this.warehouseLocationList[0] : null;
                this.getInventoryValuationReports(ReportsInventoryAPIMethods.Inventory, applyFilter);
                break;
            case ReportsInventoryNames.inventorySnapshot:
            case ReportsInventoryNames.profitability:
                this.apiName = "";
                this.getInventoryValuationReports(ReportsInventoryAPIMethods.Inventory);
                break;
            case ReportsInventoryNames.inventoryopeninvoice:
            case ReportsInventoryNames.inventoryallinvoice:
            case ReportsInventoryNames.invoiceByRep:
            case ReportsInventoryNames.profitByRep:
            case ReportsInventoryNames.shipping:
                this.apiName = "";
                this.getAllInventoryReports(ReportsInventoryAPIMethods.InventoryInvoice);
                break;
            case ReportsInventoryNames.invoiceByCustomer:
            case ReportsInventoryNames.profitByCustomer:
                this.apiName = "";
                this.showChannelFilter = true;
                this.channelList = this.accountsChannelList;
                this.selectedChannel = this.channelList ? this.selectedChannel || this.channelList.find(el => el.isDefault == true) || this.channelList[0] : null;
                this.getAllInventoryReports(ReportsInventoryAPIMethods.InventoryInvoice);
                break;
            case ReportsInventoryNames.openSalesOrders:
            case ReportsInventoryNames.picktimebypicker:
            case ReportsInventoryNames.picktimebylocation:
            case ReportsInventoryNames.packtimebypacker:
            case ReportsInventoryNames.packtimebylocation:
            case ReportsInventoryNames.backSalesOrders:
            case ReportsInventoryNames.salesOrderCommited:
                this.apiName = "";
                this.showChannelFilter = true;
                this.channelList = this.accountsChannelList;
                this.selectedChannel = this.channelList ? this.selectedChannel || this.channelList.find(el => el.isDefault == true) || this.channelList[0] : null;
                this.getAllInventoryReports(ReportsInventoryAPIMethods.InventorySalesOrder);
                break;
            case ReportsInventoryNames.accountsPayable:
                this.apiName = ReportsInventoryAPIMethods.InventoryVendor;
                this.getAllInventoryReports(ReportsInventoryAPIMethods.InventoryVendor);
                break;
            /*case ReportsInventoryNames.incomeCutomerDetail:
                this.selectedWindow = "incomeCutomerDetail";
                break;
            case ReportsInventoryNames.incomeCutomerSummary:
                this.selectedWindow = "incomeCutomerSummary";
                break;
            case ReportsInventoryNames.expensesVendorDetail:
                this.selectedWindow = "expensesVendorDetail";
                break;
            case ReportsInventoryNames.expensesVendorSummary:
                this.selectedWindow = "expensesVendorSummary";
                break;
            case ReportsInventoryNames.incomeExpenseGraph:
                this.selectedWindow = "incomeExpenseGraph";
                break;*/
            default:
                break;
        }
    }

    addRemoveAllWarehouseOption(addOrRemove: 'add' | 'remove') {
        if (this.warehouseLocationList?.length > 0) {
            this.warehouseLocationList = this.warehouseLocationList.filter(x => x.locationId != 'All');
            if (addOrRemove == 'add') {
                this.warehouseLocationList.unshift({ id: 0, name: "ALL", locationId: "All", organizationId: 0, statusId: 1 });
            }
        }

    }
    //#region //********Filter Logic******

    setFilterCols(): void {
        this.filterByInputValue = [];
        this.groupTypeColName = '';
        switch (this.selectedWindow) {
            case ReportsInventoryNames.inventoryopeninvoice: {
                this.cols = [
                    { id: 1, field: 'invoicedate', header: 'Invoice Date', dataType: 'date' },
                    { id: 2, field: 'invoicenumber', header: 'Invoice No', dataType: 'popuplink', popupLinkObject: { idColumn: 'invoiceId', module: 'Invoice' } },
                    { id: 3, field: 'accountname', header: 'Account Name', dataType: 'string' },
                    { id: 4, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 5, field: 'invoiceduedate', header: 'Due Date', dataType: 'date' },
                    { id: 6, field: 'dueamount', header: 'Amount Due', dataType: 'currencySymbol' },
                    { id: 7, field: 'comment', header: 'Memo', dataType: 'string' },
                ];
                break;
            }
            case ReportsInventoryNames.inventoryAging: {
                this.cols = [
                    { id: 1, field: 'itemNo', header: 'Item No', dataType: 'string' },
                    { id: 2, field: 'qoh', header: 'QOH', dataType: 'number' },
                    { id: 3, field: 'atp', header: 'ATP', dataType: 'number' },
                    { id: 4, field: 'lastInvoiceDate', header: 'Last Inv. Date', dataType: 'date' },
                    { id: 5, field: 'invoiceNo', header: 'Inv. No.', dataType: 'string' },
                    { id: 6, field: 'price', header: 'Sales Price', dataType: 'currencySymbol' },
                    { id: 7, field: 'aging', header: 'Aging (Days)', dataType: 'number' },
                    { id: 8, field: 'location', header: 'Loc.', dataType: 'string' },
                ]
                break;
            }
            case ReportsInventoryNames.inventoryallinvoice: {
                this.cols = [
                    { id: 1, field: 'invoicedate', header: 'Invoice Date', dataType: 'date' },
                    { id: 2, field: 'invoicenumber', header: 'Invoice No', dataType: 'popuplink', popupLinkObject: { idColumn: 'invoiceId', module: 'Invoice' } },
                    { id: 3, field: 'invoicepaymentstatus', header: 'Payment Status', dataType: 'string' },
                    { id: 4, field: 'ordertatus', header: 'Order Status', dataType: 'string' },
                    { id: 5, field: 'accountname', header: 'Account Name', dataType: 'string' },
                    { id: 6, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 7, field: 'dueamount', header: 'Amount Due', dataType: 'currencySymbol' },
                    { id: 8, field: 'comment', header: 'Memo', dataType: 'string' },
                ];
                break;
            }
            case ReportsInventoryNames.invoiceByRep: {
                this.cols = [
                    { id: 1, field: 'total', dataType: 'string', isShow: true },
                    { id: 1, field: 'repName', header: 'Rep', dataType: 'string', isShow: false },
                    {
                        id: 2, field: 'invoicenumber', header: 'Invoice No', dataType: 'popuplink',
                        popupLinkObject: { idColumn: 'invoiceId', module: 'Invoice' }, isShow: true
                    },
                    { id: 3, field: 'invoicedate', header: 'Date', dataType: 'date', isShow: true },
                    { id: 4, field: 'channelname', header: 'Channel Name', dataType: 'string', isShow: true },
                    { id: 5, field: 'accountname', header: 'Account Name', dataType: 'string', isShow: true },
                    { id: 6, field: 'itemName', header: 'Item', dataType: 'string', isShow: true },
                    { id: 7, field: 'quantity', header: 'Qty', dataType: 'string', isShow: true },
                    { id: 8, field: 'salePrice', header: 'Sale Price', dataType: 'currencySymbol', isShow: true },
                    { id: 9, field: 'amount', header: 'Amount', dataType: 'currencySymbol', isShow: true },
                    { id: 10, field: 'amountDue', header: 'Balance Amount', dataType: 'currencySymbolIgnoreTotal', isShow: true },
                ];

                this.groupTypeColName = 'groupRepName';
                break;
            }
            case ReportsInventoryNames.invoiceByCustomer: {
                this.cols = [
                    { id: 1, field: 'total', dataType: 'string', isShow: true },
                    { id: 1, field: 'accountname', header: 'Account Name', dataType: 'string', isShow: false },
                    {
                        id: 2, field: 'invoicenumber', header: 'Invoice No', dataType: 'popuplink',
                        popupLinkObject: { idColumn: 'invoiceId', module: 'Invoice' }, isShow: true
                    },
                    { id: 3, field: 'invoicedate', header: 'Invoice Date', dataType: 'date', isShow: true },
                    { id: 4, field: 'itemName', header: 'Item', dataType: 'string', isShow: true },
                    { id: 5, field: 'quantity', header: 'Qty', dataType: 'string', isShow: true },
                    { id: 6, field: 'salePrice', header: 'Sale Price', dataType: 'currencySymbol', isShow: true },
                    { id: 7, field: 'amount', header: 'Amount', dataType: 'currencySymbol', isShow: true },
                    { id: 8, field: 'amountDue', header: 'Balance Amount', dataType: 'currencySymbolIgnoreTotal', isShow: true },
                ];
                this.groupTypeColName = 'groupCustomerName';
                break;
            }
            case ReportsInventoryNames.profitByRep: {
                this.cols = [
                    { id: 1, field: 'total', dataType: 'string', isShow: true },
                    { id: 1, field: 'repName', header: 'Rep', dataType: 'string', isShow: false },
                    {
                        id: 2, field: 'invoicenumber', header: 'Invoice No', dataType: 'popuplink',
                        popupLinkObject: { idColumn: 'invoiceId', module: 'Invoice' }, isShow: true
                    },
                    { id: 3, field: 'invoicedate', header: 'Date', dataType: 'date', isShow: true },
                    { id: 4, field: 'channelname', header: 'Channel Name', dataType: 'string', isShow: true },
                    { id: 5, field: 'accountname', header: 'Account Name', dataType: 'string', isShow: true },
                    { id: 6, field: 'itemNo', header: 'Item', dataType: 'string', isShow: true },
                    { id: 7, field: 'quantity', header: 'Qty', dataType: 'string', isShow: true },
                    { id: 8, field: 'cost', header: 'Cost', dataType: 'currencySymbol', isShow: true },
                    { id: 9, field: 'salePrice', header: 'Sale Price', dataType: 'currencySymbol', isShow: true },
                    { id: 10, field: 'discount', header: 'Discount', dataType: 'currencySymbol', isShow: true },
                    { id: 11, field: 'grossProfit', header: 'Gross Profit', dataType: 'currencySymbol', isShow: true },
                ];
                if (!this.findDiscountRow) {
                    this.cols.splice(10, 1);
                }
                this.groupTypeColName = 'groupRepName';
                break;
            }
            case ReportsInventoryNames.profitByCustomer: {
                this.cols = [
                    { id: 1, field: 'total', dataType: 'string', isShow: true },
                    { id: 1, field: 'accountname', header: 'Account Name', dataType: 'string', isShow: false },
                    {
                        id: 2, field: 'invoicenumber', header: 'Invoice No', dataType: 'popuplink',
                        popupLinkObject: { idColumn: 'invoiceId', module: 'Invoice' }, isShow: true
                    },
                    { id: 3, field: 'invoicedate', header: 'Date', dataType: 'date', isShow: true },
                    { id: 4, field: 'itemName', header: 'Item', dataType: 'string', isShow: true },
                    { id: 5, field: 'quantity', header: 'Qty', dataType: 'string', isShow: true },
                    { id: 6, field: 'cost', header: 'Cost', dataType: 'currencySymbol', isShow: true },
                    { id: 7, field: 'salePrice', header: 'Sale Price', dataType: 'currencySymbol', isShow: true },
                    { id: 8, field: 'discount', header: 'Discount', dataType: 'currencySymbol', isShow: true },
                    { id: 9, field: 'grossProfit', header: 'Gross Profit', dataType: 'currencySymbol', isShow: true },
                ];
                if (!this.findDiscountRow) {
                    this.cols.splice(8, 1);
                }
                this.groupTypeColName = 'groupCustomerName';
                break;
            }
            case ReportsInventoryNames.accountsReceivable: {
                this.cols = [
                    { id: 1, field: 'accountname', header: 'Account Name', dataType: 'string' },
                    { id: 2, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 5, field: 'current', header: 'Current', dataType: 'currencySymbol' },
                    { id: 6, field: 'one_thirty', header: '1 - 30 days', dataType: 'currencySymbol' },
                    { id: 7, field: 'thirtyone_sixty', header: '31 - 60 days', dataType: 'currencySymbol' },
                    { id: 8, field: 'sixtyone_ninety', header: '61 - 90 days', dataType: 'currencySymbol' },
                    { id: 9, field: 'grater_than_90', header: '> 90 days', dataType: 'currencySymbol' },
                    { id: 10, field: 'totalamount', header: 'Total', dataType: 'currencySymbol' },
                ];
                this.detailsCols = [
                    { id: 1, field: 'accountname', header: 'Account Name', dataType: 'string' },
                    { id: 2, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 3, field: 'repname', header: 'Rep Name', dataType: 'string' },
                    { id: 4, field: 'paymentterm', header: 'Payment Term', dataType: 'string' },
                    { id: 5, field: 'invoiceno', header: 'Invoice No.', dataType: 'popuplink', popupLinkObject: { idColumn: 'invoiceid', module: 'Invoice' } },
                    { id: 6, field: 'invoiceamount', header: 'Invoice Amount', dataType: 'currencySymbol' },
                    { id: 7, field: 'invoicedate', header: 'Invoice Date', dataType: 'date' },
                    { id: 8, field: 'invoiceduedate', header: 'Due Date', dataType: 'date' },
                    { id: 9, field: 'aging', header: 'Aging', dataType: 'string' },
                ];
                this.detailsHeader = this.reportName;
                break;
            }
            case ReportsInventoryNames.accountsPayable: {
                this.cols = [
                    { id: 1, field: 'vendorname', header: 'Vendor Name', dataType: 'string' },
                    { id: 4, field: 'current', header: 'Current', dataType: 'currencySymbol' },
                    { id: 5, field: 'one_thirty', header: '1 - 30 days', dataType: 'currencySymbol' },
                    { id: 6, field: 'thirtyone_sixty', header: '31 - 60 days', dataType: 'currencySymbol' },
                    { id: 7, field: 'sixtyone_ninety', header: '61 - 90 days', dataType: 'currencySymbol' },
                    { id: 8, field: 'grater_than_90', header: '> 90 days', dataType: 'currencySymbol' },
                    { id: 9, field: 'totaldueamount', header: 'Total', dataType: 'currencySymbol' },
                ];
                this.detailsCols = [
                    { id: 1, field: 'vendorname', header: 'Vendor Name', dataType: 'string' },
                    { id: 2, field: 'repname', header: 'Rep Name', dataType: 'string' },
                    { id: 3, field: 'paymentterm', header: 'Payment Term', dataType: 'string' },
                    { id: 4, field: 'purchaseordernumber', header: 'Order No.', dataType: 'popuplink', popupLinkObject: { idColumn: 'purchaseorderid', module: 'PurchaseOrder' } },
                    { id: 5, field: 'totaldueamount', header: 'Due Amount', dataType: 'currencySymbol' },
                    { id: 6, field: 'podate', header: 'PO Date', dataType: 'date' },
                    { id: 7, field: 'duedate', header: 'Due Date', dataType: 'date' },
                    { id: 8, field: 'aging', header: 'Aging', dataType: 'string' },
                ];
                this.detailsHeader = this.reportName;
                break;
            }
            case ReportsInventoryNames.profitability: {
                this.cols = [
                    { id: 1, field: 'itemno', header: 'Item No.', dataType: 'string' },
                    { id: 2, field: 'itemdescription', header: 'Item Details', dataType: 'string' },
                    { id: 3, field: 'location', header: 'Location ID', dataType: 'string' },
                    { id: 4, field: 'quantitysold', header: 'Qty Sold', dataType: 'number' },
                    { id: 5, field: 'totalrevenue', header: 'Total Revenue', dataType: 'currencySymbol' },
                    { id: 6, field: 'grossprofit', header: 'Gross Profit', dataType: 'currencySymbol' },
                    { id: 7, field: 'totalprofitper', header: 'Total Profit %', dataType: 'percentageSymbol' },
                    { id: 8, field: 'grossprofitper', header: 'Gross Profit %', dataType: 'percentageSymbol' }
                ];
                break;
            }
            case ReportsInventoryNames.shipping: {
                this.cols = [
                    { id: 1, field: 'channelName', header: 'Channel Name', dataType: 'string' },
                    { id: 2, field: 'accountName', header: 'Account Name', dataType: 'string' },
                    { id: 3, field: 'streetAddress', header: 'Street Addr.', dataType: 'string' },
                    { id: 4, field: 'city', header: 'City', dataType: 'string' },
                    { id: 5, field: 'state', header: 'State', dataType: 'string' },
                    { id: 6, field: 'zipCode', header: 'Zip Code', dataType: 'string' },
                    { id: 7, field: 'weight', header: 'Weight', dataType: 'string' },
                    { id: 8, field: 'packagedDimension', header: 'Package Dimension', dataType: 'string' },
                    { id: 9, field: 'invoiceNo', header: 'Invoice No.', dataType: 'string' },
                    { id: 10, field: 'invoiceDate', header: 'Invoice Date', dataType: 'date' },
                    { id: 11, field: 'shippingMethod', header: 'Shipping Method', dataType: 'string' },
                    { id: 12, field: 'trackingNo', header: 'Tracking No.', dataType: 'string' },
                ];
                break;
            }
            case ReportsInventoryNames.openSalesOrders: {
                this.cols = [
                    { id: 1, field: 'salesorderdate', header: 'SO Date', dataType: 'date' },
                    { id: 2, field: 'salesorderno', header: 'SO No.', dataType: 'string' },
                    { id: 3, field: 'salesorderstatus', header: 'SO Status', dataType: 'string' },
                    { id: 4, field: 'salesorderstage', header: 'SO Stage', dataType: 'string' },
                    { id: 5, field: 'location', header: 'Location', dataType: 'string' },
                    // { id: 6, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 7, field: 'accountname', header: 'Account Name', dataType: 'string' },
                    { id: 8, field: 'createdbyname', header: 'Created By', dataType: 'string' },
                    { id: 9, field: 'repame', header: 'Rep Name', dataType: 'string' },
                    { id: 10, field: 'netamount', header: 'Amount', dataType: 'currencySymbol' },
                ];
                break;
            }
            case ReportsInventoryNames.picktimebypicker:
            case ReportsInventoryNames.packtimebypacker: {
                this.cols = [
                    // { id: 1, field: 'salesorderdate', header: 'SO Date', dataType: 'date' },
                    // { id: 2, field: 'salesorderno', header: 'SO No.', dataType: 'string' },
                    // { id: 3, field: 'salesorderstage', header: 'SO Stage', dataType: 'string' },
                    { id: 1, field: 'pickerPackerName', header: this.selectedWindow == ReportsInventoryNames.picktimebypicker ? 'Picker Name' : 'Packer Name', dataType: 'string' },
                    // { id: 4, field: 'location', header: 'Location', dataType: 'string' },
                    // { id: 5, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 2, field: 'avgPickPackTime', header: this.selectedWindow == ReportsInventoryNames.picktimebypicker ? 'Avg Pick Time (hh:mm:ss)' : 'Avg Pack Time (hh:mm:ss)', dataType: 'timespan' },
                ];
                this.detailsCols = [
                    { id: 1, field: 'salesOrderDate', header: 'SO Date', dataType: 'date' },
                    { id: 2, field: 'salesOrderNo', header: 'SO No.', dataType: 'string' },
                    { id: 3, field: 'location', header: 'Location', dataType: 'string' },
                    { id: 4, field: 'accountName', header: 'Account Name', dataType: 'string' },
                    { id: 5, field: 'picPackQty', header: this.selectedWindow == ReportsInventoryNames.picktimebypicker ? 'Total Picked Qty' : 'Total Packed Qty', dataType: 'number' },
                    { id: 6, field: 'total', header: 'Order Total', dataType: 'currencySymbol' },
                    { id: 7, field: 'pickPackTime', header: this.selectedWindow == ReportsInventoryNames.picktimebypicker ? 'Pick Time (hh:mm:ss)' : 'Pack Time (hh:mm:ss)', dataType: 'timespan' },
                ];
                this.detailsHeader = this.selectedWindow == ReportsInventoryNames.picktimebypicker ? 'Pick Time by Picker' : 'Pack Time by Packer';
                break;
            }
            case ReportsInventoryNames.picktimebylocation:
            case ReportsInventoryNames.packtimebylocation: {
                this.cols = [
                    // { id: 1, field: 'salesorderdate', header: 'SO Date', dataType: 'date' },
                    // { id: 2, field: 'salesorderno', header: 'SO No.', dataType: 'string' },
                    // { id: 3, field: 'salesorderstage', header: 'SO Stage', dataType: 'string' },
                    { id: 1, field: 'location', header: 'Location', dataType: 'string' },
                    // { id: 6, field: 'pickerPackerName', header: this.selectedWindow == ReportsInventoryNames.picktimebylocation ? 'Picker Name' : 'Packer Name', dataType: 'string' },
                    // { id: 5, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 2, field: 'avgPickPackTime', header: this.selectedWindow == ReportsInventoryNames.picktimebylocation ? 'Avg Pick Time (hh:mm:ss)' : 'Avg Pack Time (hh:mm:ss)', dataType: 'timespan' },
                ];
                this.detailsCols = [
                    { id: 1, field: 'salesOrderDate', header: 'SO Date', dataType: 'date' },
                    { id: 2, field: 'salesOrderNo', header: 'SO No.', dataType: 'string' },
                    // { id: 3, field: 'location', header: 'Location', dataType: 'string' },
                    { id: 3, field: 'pickerPackerName', header: this.selectedWindow == ReportsInventoryNames.picktimebylocation ? 'Picker Name' : 'Packer Name', dataType: 'string' },
                    { id: 4, field: 'accountName', header: 'Account Name', dataType: 'string' },
                    { id: 5, field: 'picPackQty', header: this.selectedWindow == ReportsInventoryNames.picktimebylocation ? 'Total Picked Qty' : 'Total Packed Qty', dataType: 'number' },
                    { id: 6, field: 'total', header: 'Order Total', dataType: 'currencySymbol' },
                    { id: 7, field: 'pickPackTime', header: this.selectedWindow == ReportsInventoryNames.picktimebylocation ? 'Pick Time (hh:mm:ss)' : 'Pack Time (hh:mm:ss)', dataType: 'timespan' },
                ];
                this.detailsHeader = this.selectedWindow == ReportsInventoryNames.picktimebylocation ? 'Pick Time by Location' : 'Pack Time by Location';
                break;
            }
            case ReportsInventoryNames.backSalesOrders: {
                this.cols = [
                    { id: 1, field: 'salesorderdate', header: 'SO Date', dataType: 'date' },
                    { id: 2, field: 'salesorderno', header: 'SO No.', dataType: 'string' },
                    { id: 3, field: 'itemname', header: 'Item Name', dataType: 'string' },
                    // { id: 4, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 5, field: 'accountname', header: 'Account Name', dataType: 'string' },
                    { id: 6, field: 'orderqty', header: 'Ord Qty', dataType: 'string' },
                    { id: 7, field: 'shippedqty', header: 'Ship Qty', dataType: 'string' },
                    { id: 8, field: 'backqty', header: 'BKO Qty', dataType: 'string' },
                    { id: 9, field: 'qoh', header: 'QOH', dataType: 'string' },
                    { id: 10, field: 'atp', header: 'ATP', dataType: 'string' },
                ];
                break;
            }
            case ReportsInventoryNames.salesOrderCommited: {
                this.cols = [
                    { id: 1, field: 'salesorderdate', header: 'SO Date', dataType: 'date' },
                    { id: 2, field: 'salesorderno', header: 'SO No.', dataType: 'string' },
                    { id: 3, field: 'salesorderstatus', header: 'SO Status', dataType: 'string' },
                    { id: 4, field: 'salesorderstage', header: 'SO Stage', dataType: 'string' },
                    { id: 5, field: 'location', header: 'Location', dataType: 'string' },
                    // { id: 6, field: 'channelname', header: 'Channel Name', dataType: 'string' },
                    { id: 7, field: 'accountname', header: 'Account Name', dataType: 'string' },
                    { id: 8, field: 'createdbyname', header: 'Created By', dataType: 'string' },
                    { id: 9, field: 'repame', header: 'Rep Name', dataType: 'string' },
                    { id: 10, field: 'netamount', header: 'Amount', dataType: 'currencySymbol' },
                ];
                break;
            }
            case ReportsInventoryNames.inventoryValuationSummary: {
                this.cols = [
                    { id: 1, field: 'location', header: 'Location ID', dataType: 'string', isShow: true },
                    { id: 2, field: 'itemNo', header: 'Item No.', dataType: 'string', isShow: true },
                    { id: 3, field: 'itemName', header: 'Item Name', dataType: 'string', isShow: true },
                    { id: 4, field: 'qoh', header: 'QOH', dataType: 'string', isShow: true },
                    { id: 5, field: 'avgCost', header: 'Avg Cost', dataType: 'currencySymbol', isShow: true },
                    { id: 6, field: 'assetValue', header: 'Asset Value', dataType: 'currencySymbol', isShow: true },
                    { id: 7, field: 'salesPrice', header: 'Sales Price', dataType: 'currencySymbol', isShow: true },
                    { id: 8, field: 'assetPer', header: '% of Total Asset', dataType: 'percentageSymbol', isShow: true },
                ];
                // this.showInActive = true;
                break;
            }
            case ReportsInventoryNames.inventoryValuationDetail: {
                this.cols = [
                    { id: 1, field: 'total', dataType: 'string', isShow: true },
                    { id: 1, field: 'createdDate', header: 'Date', dataType: 'date', isShow: true },
                    { id: 2, field: 'location', header: 'Location ID', dataType: 'string', isShow: true },
                    { id: 3, field: 'txType', header: 'Tx Type', dataType: 'string', isShow: true },
                    { id: 4, field: 'txId', header: 'Tx ID', dataType: 'string', isShow: true },
                    { id: 5, field: 'itemName', header: 'Name', dataType: 'string', isShow: true },
                    { id: 6, field: 'quantity', header: 'Qty', dataType: 'string', isShow: true },
                    { id: 7, field: 'cost', header: 'Cost', dataType: 'currencySymbol', isShow: true },
                    { id: 7, field: 'avgCost', header: 'Avg Cost', dataType: 'currencySymbol', isShow: true },
                    { id: 8, field: 'totalCost', header: 'Total Cost', dataType: 'currencySymbol', isShow: true },
                    { id: 9, field: 'qoh', header: 'QOH', dataType: 'string', isShow: true },
                    { id: 10, field: 'assetValue', header: 'Asset Value', dataType: 'currencySymbol', isShow: true },
                ];
                // this.showInActive = true;
                this.groupTypeColName = 'itemNameNo';
                break;
            }
            case ReportsInventoryNames.inventorySnapshot: {
                this.cols = [
                    { id: 1, field: 'locationId', header: 'Location ID', dataType: 'string' },
                    { id: 2, field: 'qoh', header: 'QOH', dataType: 'number' },
                    { id: 3, field: 'atp', header: 'ATP', dataType: 'number' },
                    { id: 4, field: 'qtyOnOrder', header: 'Qty On Order', dataType: 'number' },
                    { id: 5, field: 'qtyCommitted', header: 'Qty Committed', dataType: 'number' },
                    { id: 6, field: 'reOrderPoint', header: 'Reorder Point', dataType: 'string' },
                    { id: 7, field: 'qtyToOrder', header: 'Qty to Order', dataType: 'number' },
                    { id: 8, field: 'stockLevel', header: 'Pref Stock Level', dataType: 'percentageSymbol' },
                ];
                this.groupTypeColName = 'itemNameNo';
                break;
            }
            default:
                this.cols = [];
                break;
        }
        //set filter value
        this.setFilterValues(this.reportDatas);
    }

    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.onApplyFilter(selectedWindow, selectedFilters);
    }
    onClosePanel(selectedWindow: string): void {
    }

    updateFieldNames(data) {
        const fieldMappings = {
            "itemNo": "ItemNo",
            "qoh": "QOH",
            "atp": "ATP",
            "lastSaleDate": "LastSaleDate",
            "invNo": "InvNo",
            "aging": "Aging",
            "salesPrice": "SalesPrice",
            "warehouseName": "WarehouseName"
        };
        return data.map(item => {
            const updatedField = fieldMappings[item.field] || item.field;
            return { ...item, field: updatedField };
        });
    }

    //when apply any filter
    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.selectedFilterVm = selectedFilters;
        if (this.selectedWindow != ReportsInventoryNames.inventoryAging) {
            this.applyFilter(selectedWindow, selectedFilters, 'apply');
        }
        if (this.selectedWindow == ReportsInventoryNames.inventoryAging) {
            const updatedSelectedFilterVm = this.updateFieldNames(this.selectedFilterVm);
            const values = updatedSelectedFilterVm.map(item => {
                return {
                    "Field": item.field,
                    "Datatype": item.dataType,
                    "Values": [item.value]
                };
            });
            this.GetFilterAgingReport(values)
        }

    }
    //when Edit applied filter
    onModifyFilterOptions(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.applyFilter(selectedWindow, selectedFilters, 'modify');
    }

    //Apply Filter logic
    private applyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[], applyType: 'apply' | 'modify') {
        let reportsData = ParseHelper.DeepCopy(this.reportDatasCopy);
        switch (this.selectedWindow) {
            case ReportsInventoryNames.inventoryallinvoice:
            case ReportsInventoryNames.invoiceByRep:
            case ReportsInventoryNames.invoiceByCustomer:
            case ReportsInventoryNames.profitByRep:
            case ReportsInventoryNames.profitByCustomer:
            case ReportsInventoryNames.inventoryopeninvoice:
            case ReportsInventoryNames.accountsReceivable:
            case ReportsInventoryNames.openSalesOrders:
            case ReportsInventoryNames.accountsPayable:
            case ReportsInventoryNames.profitability:
            case ReportsInventoryNames.shipping:
            case ReportsInventoryNames.picktimebypicker:
            case ReportsInventoryNames.picktimebylocation:
            case ReportsInventoryNames.packtimebypacker:
            case ReportsInventoryNames.packtimebylocation:
            case ReportsInventoryNames.backSalesOrders:
            case ReportsInventoryNames.salesOrderCommited:
            case ReportsInventoryNames.inventoryValuationDetail:
            case ReportsInventoryNames.inventoryValuationSummary:
            case ReportsInventoryNames.inventorySnapshot:
                //filter table
                if (selectedFilters?.length > 0) {
                    selectedFilters?.forEach(filt => {
                        if (filt.dataType == 'date') {
                            reportsData = reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'MM-DD-YYYY') == filt.value) ?? [];
                        }
                        // else if (filt.dataType == 'number2dp') {
                        //     reportsData = reportsData?.filter(x => (x[filt.field]?.toFixed(2) ?? x[filt.field]) == filt.value) ?? [];
                        // }
                        else {
                            reportsData = reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                        }
                    });
                }
                break;
            default:
                break;
        }
        if (applyType == 'apply') {
            this.reportDatas = ParseHelper.DeepCopy(reportsData);
        }
        //set filter value
        this.setFilterValues(reportsData, applyType);
    }
    //When date filter dropdown change
    onChangeRange(selectedWindow: string, event: { dateFrom: any, dateTo: any, selectedDateFilter: any }): void {
        this.dateFrom = event.dateFrom;
        this.dateTo = event.dateTo;
        this.filterType = event.selectedDateFilter;
        this.getInventoryReportData();
    }

    onChangeChannel(selectedChannel: any) {
        this.selectedChannel = selectedChannel;
        this.getInventoryReportData();
    }

    onChangeWarehouseLocation(selectedWarehouseLocation: any) {
        this.selectedWarehouseLocation = selectedWarehouseLocation;
        this.getInventoryReportData();
    }

    private setFilterValues(reportsData: any[], applyType: 'apply' | 'modify' = 'apply'): void {
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case ReportsInventoryNames.accountsReceivable:
            case ReportsInventoryNames.accountsPayable:
                if (applyType == 'apply') {
                    this.getTotalOfTable();
                }
                this.filterByInputValue = [...reportsData];
                break;
            case ReportsInventoryNames.inventoryopeninvoice:
            case ReportsInventoryNames.inventoryallinvoice:
            case ReportsInventoryNames.invoiceByRep:
            case ReportsInventoryNames.invoiceByCustomer:
            case ReportsInventoryNames.profitByCustomer:
            case ReportsInventoryNames.profitByRep:
            case ReportsInventoryNames.inventoryValuationSummary:
                if (applyType == 'apply') {
                    this.getTotalOfTable();
                }
                this.filterByInputValue = [...reportsData];
                break;
            case ReportsInventoryNames.openSalesOrders:
            case ReportsInventoryNames.profitability:
            case ReportsInventoryNames.shipping:
            case ReportsInventoryNames.picktimebypicker:
            case ReportsInventoryNames.picktimebylocation:
            case ReportsInventoryNames.packtimebypacker:
            case ReportsInventoryNames.packtimebylocation:
            case ReportsInventoryNames.backSalesOrders:
            case ReportsInventoryNames.salesOrderCommited:
            case ReportsInventoryNames.inventoryAging:
            case ReportsInventoryNames.inventoryValuationDetail:
                if (applyType == 'apply') {
                    this.getTotalOfTable();
                }
                this.filterByInputValue = [...reportsData];
                break;
            case ReportsInventoryNames.inventorySnapshot:
                this.filterByInputValue = [...reportsData];
                break;
            default:
                break;
        }
    }
    //on click table row
    onTableRowClick(event: any): void {
        this.reportRowDetails = [];
        this.detailsHeaderTitle = '';
        switch (this.selectedWindow) {
            case ReportsInventoryNames.accountsReceivable:
                this.detailsHeaderTitle = event?.accountname;
                this.detailsGroupTypeColName = 'pas_due_days_group';
                this.getReportRowDetails('accountsReceivableDetail', this.selectedChannel?.id ?? 0, ReportsInventoryAPIMethods.AccountsReceivableDetail, `&accountId=${event.accountid}`)
                break;
            case ReportsInventoryNames.accountsPayable:
                this.detailsHeaderTitle = event?.vendorname;
                this.detailsGroupTypeColName = 'pas_due_days_group';
                this.getReportRowDetails('accountsPayableDetail', this.selectedChannel?.id ?? 0, ReportsInventoryAPIMethods.AccountsPayableDetail, `&vendorId=${event.vendorid}`)
                break;
            case ReportsInventoryNames.picktimebypicker:
            case ReportsInventoryNames.packtimebypacker:
                this.detailsHeaderTitle = event?.pickerPackerName;
                this.detailsGroupTypeColName = 'location';
                this.getReportRowDetails(this.selectedWindow, this.selectedChannel?.id ?? 0, ReportsInventoryAPIMethods.InventoryAvgPickPackDetail, `&objectRefId=${event.pickerPackerId}`)
                break;
            case ReportsInventoryNames.picktimebylocation:
            case ReportsInventoryNames.packtimebylocation:
                this.detailsHeaderTitle = event?.location;
                this.detailsGroupTypeColName = 'pickerPackerName';
                this.getReportRowDetails(this.selectedWindow, this.selectedChannel?.id ?? 0, ReportsInventoryAPIMethods.InventoryAvgPickPackDetail, `&objectRefId=${event.wareHouseId}`)
                break;
            default:
                break;
        }
    }

    onShowInActiveClick(showInActive: boolean = false): void {
        this.showInActive = showInActive;
        if (this.selectedWindow == ReportsInventoryNames.inventoryValuationSummary
            || this.selectedWindow == ReportsInventoryNames.inventoryValuationDetail) {
            this.getInventoryReportData(this.selectedFilterVm != null ? true : false);
        }
    }

    getTotalOfTable(): void {
        this.reportTotalRow = {};
        if (this.reportDatas.length > 0 && this.cols?.length > 0) {
            const firstCol = this.cols[0];
            let obj = {};
            for (let col of this.cols) {
                //First col
                if (firstCol.field == col.field) {
                    obj[col.field] = 'Total';
                }
                else if (col.dataType == 'currencySymbol' || col.dataType == 'number2dp' || col.dataType == 'number') {

                    if (this.selectedWindow == ReportsInventoryNames.inventoryValuationDetail && col.field == 'assetValue') {
                        let data = JSON.parse(JSON.stringify(this.reportDatas));
                        let assetTotal = 0;
                        for (let i = 0; i < this.reportDatas.length; i++) {
                            if (data[i]?.itemNameNo != data[i + 1]?.itemNameNo) {
                                let lastAssetValue = data[i]?.assetValue;
                                assetTotal += lastAssetValue;
                            }

                        }
                        obj['assetValue'] = assetTotal;
                    }
                    else if (this.selectedWindow == ReportsInventoryNames.inventoryValuationDetail && col.field != 'assetValue') {
                        const total = this.reportDatas?.filter(data => data[col.field])?.reduce((sum, data) => data[col.field] + sum, 0);
                        obj[col.field] = total == 0 ? null : total;
                    }
                    else {
                        const total = this.reportDatas?.filter(data => data[col.field])?.reduce((sum, data) => data[col.field] + sum, 0);
                        obj[col.field] = total == 0 ? null : total;
                    }
                }
                else {
                    obj[col.field] = '';
                }
            }
            this.reportTotalRow = obj;
            if (this.selectedWindow == ReportsInventoryNames.profitByCustomer
                || this.selectedWindow == ReportsInventoryNames.profitByRep
                || this.selectedWindow == ReportsInventoryNames.invoiceByRep
                || this.selectedWindow == ReportsInventoryNames.invoiceByCustomer
                || this.selectedWindow == ReportsInventoryNames.inventoryValuationDetail) {
                this.processDataforGroupTotalRow();
            }

        }
    }

    getTotalOfDetailsTable(): void {
        this.reportDetailsTotalRow = {};
        if (this.reportRowDetails?.length > 0 && this.detailsCols?.length > 0) {
            const firstCol = this.detailsCols[0];
            let obj = {};
            for (let col of this.detailsCols) {
                //First col
                if (firstCol.field == col.field) {
                    obj[col.field] = 'Total';
                }
                else if (col.dataType == 'currencySymbol' || col.dataType == 'number2dp' || col.dataType == 'number') {
                    const total = this.reportRowDetails?.filter(data => data[col.field])?.reduce((sum, data) => data[col.field] + sum, 0);
                    obj[col.field] = total == 0 ? null : total;
                }
                else {
                    obj[col.field] = '';
                }
            }
            this.reportDetailsTotalRow = obj;
        }
    }

    processDataforGroupTotalRow(): void {
        let data = JSON.parse(JSON.stringify(this.reportDatas));
        let copyData = [];

        let helper = {};
        let key: any;

        let sum = data.reduce((r, o, index) => {
            if (this.selectedWindow == ReportsInventoryNames.profitByRep
                || this.selectedWindow == ReportsInventoryNames.invoiceByRep) {
                key = o.groupRepName;
            }
            else if (this.selectedWindow == ReportsInventoryNames.profitByCustomer
                || this.selectedWindow == ReportsInventoryNames.invoiceByCustomer) {
                key = o.groupCustomerName;
            }
            else if (this.selectedWindow == ReportsInventoryNames.inventoryValuationDetail) {
                key = o.itemNameNo;
            }
            else {
                return;
            }

            if (key) {
                if (!helper[key]) {
                    helper[key] = Object.assign({}, o);
                    r.push(helper[key]);
                }
                else {
                    if (this.selectedWindow == ReportsInventoryNames.profitByRep
                        || this.selectedWindow == ReportsInventoryNames.profitByCustomer) {
                        helper[key].salePrice += o.salePrice;
                        helper[key].cost += o.cost;
                        helper[key].discount += o.discount;
                        helper[key].grossProfit += o.grossProfit;
                    }
                    else if (this.selectedWindow == ReportsInventoryNames.invoiceByRep
                        || this.selectedWindow == ReportsInventoryNames.invoiceByCustomer) {
                        helper[key].salePrice += o.salePrice;
                        helper[key].amount += o.amount;
                        //helper[key].amountDue += o.amountDue;
                    }
                    else if (this.selectedWindow == ReportsInventoryNames.inventoryValuationDetail) {

                        if (data[index]?.itemNameNo != data[index + 1]?.itemNameNo) {
                            helper[key].assetValue = data[index]?.assetValue;
                        }
                    }
                }
            }

            return r;
        }, []);
        let totalSum = sum.map(obj => {
            return (
                {
                    total: 'Total',
                    salePrice: obj?.salePrice,
                    cost: this.selectedWindow == ReportsInventoryNames.inventoryValuationDetail ? null : obj?.cost,
                    groupRepName: obj?.groupRepName,
                    groupCustomerName: obj?.groupCustomerName,
                    discount: obj?.discount,
                    grossProfit: obj?.grossProfit,
                    amount: obj?.amount,
                    assetValue: obj?.assetValue,
                    itemNameNo: obj?.itemNameNo
                    //amountDue: obj?.amountDue
                });
        });
        //console.log("sum", totalSum);
        let sumCount = 0;
        for (let i = 0; i < this.reportDatas.length; i++) {
            copyData.push(data[i]);

            if (this.selectedWindow === ReportsInventoryNames.profitByRep || this.selectedWindow === ReportsInventoryNames.invoiceByRep) {
                if (data[i]?.repName != data[i + 1]?.repName) {
                    copyData.push(totalSum[sumCount]);
                    sumCount++;
                }
            }
            else if (this.selectedWindow == ReportsInventoryNames.profitByCustomer || this.selectedWindow === ReportsInventoryNames.invoiceByCustomer) {
                if (data[i]?.accountname != data[i + 1]?.accountname) {
                    copyData.push(totalSum[sumCount]);
                    sumCount++;
                }
            }
            else if (this.selectedWindow == ReportsInventoryNames.inventoryValuationDetail) {
                if (data[i]?.itemNameNo != data[i + 1]?.itemNameNo) {
                    copyData.push(totalSum[sumCount]);
                    sumCount++;
                }
            }

        }
        //console.log("copyData", copyData);
        this.reportDatas = JSON.parse(JSON.stringify([]));
        this.reportDatas = JSON.parse(JSON.stringify(copyData));
        // if (this.reportDatas != null) {
        //     let cols = this.cols;
        //     this.filteredCols = cols.slice(1);
        // }
    }



    //#endregion

    //#region //********Print And Export(PDF & Excel)***********//

    print(): void {
        this.appMainService.isShowSpinner('Print');
        this.exportPDF(this.selectedWindow, true);
        this.appMainService.isHideSpinner('Print');
    }

    exportPDF(selectedWindow: string, isPrintFlag = false): void {
        this.pdfInventoryReport(this.reportDatas, this.cols, this.getTableGroupColName(), selectedWindow, this.reportName, isPrintFlag);
    }

    exportXLS(selectedWindow: string): void {
        this.excelExportInventoryReport(this.reportDatas, this.cols, this.getTableGroupColName(), selectedWindow, this.reportName, "XLSX");
    }

    exportXLSX(selectedWindow: string): void {
        this.excelExportInventoryReport(this.reportDatas, this.cols, this.getTableGroupColName(), selectedWindow, this.reportName, "XLSX");
    }

    pdfInventoryReport(data: any, cols: any, groupCol: IReportsColumnModel, selectedWindow: string, reportName: string, isPrintFlag: boolean, isDetailsPrint: boolean = false): void {
        let dataResult = this.prepareExportDataResult(data, cols, groupCol, true, isDetailsPrint);
        ReportsPrintPdfService.openOrExportAsPDF(this.setPDFColumns(cols), dataResult, this.organizationName, this.dateFrom, this.dateTo, reportName, null, null, isPrintFlag);
    }

    excelExportInventoryReport(data: any, cols: any, groupCol: IReportsColumnModel, selectedWindow: string, reportName: string, exportType: 'XLS' | 'XLSX', isDetailsPrint: boolean = false): void {
        let dataResult = this.prepareExportDataResult(data, cols, groupCol, false, isDetailsPrint);
        ReportsExportExcelService.exportAsExcel(exportType, dataResult, this.organizationName, this.reportName);
    }

    //Get group column of grouptable
    getTableGroupColName(): IReportsColumnModel | null {
        if (this.groupTypeColName) {
            return this.cols?.find(x => x.field == this.groupTypeColName) ?? { id: 1, field: this.groupTypeColName, header: this.groupTypeColName, dataType: 'string' };
        }
        return null;
    }
    //Prepare DataResutl For PDF/Excel
    prepareExportDataResult(data: any, cols: IReportsColumnModel[], groupCol: IReportsColumnModel, isPDF: boolean = false, isDetailsPrint: boolean = false): any[] {
        const actData = ParseHelper.DeepCopy(data);
        const dataResult: any[] = [];
        let groupColValue = '';
        for (let data of actData) {
            const obj = {};
            for (let col of cols) {
                if (col.dataType == 'date') {
                    obj[isPDF ? col.field : col.header] = this.localDatePipe.transform(data[col.field], 'MM/DD/YYYY')
                }
                else if (col.dataType == 'number2dp') {
                    obj[isPDF ? col.field : col.header] = data[col.field]?.toFixed(2) ?? data[col.field];
                }
                else if (col.dataType == 'currencySymbol') {
                    obj[isPDF ? col.field : col.header] = this.currencySymbolPipe.transform(data[col.field], 'number2dp') ?? data[col.field];
                }
                else if (col.dataType == 'percentageSymbol') {
                    obj[isPDF ? col.field : col.header] = this.percentageSymbolPipe.transform(data[col.field], 'number2dp') ?? data[col.field];
                }
                else if (col.dataType == 'timespan') {
                    obj[isPDF ? col.field : col.header] = this.timeConvertPipe.transform(data[col.field]) ?? data[col.field];
                }
                else {
                    obj[isPDF ? col.field : col.header] = data[col.field];
                }
            }

            //#region Push Group Row
            const groupObj = {};
            if (groupCol) {
                if (groupColValue !== data[groupCol.field]) {
                    const firstCol = cols[0];
                    if (groupCol.dataType == 'date') {
                        groupObj[isPDF ? firstCol.field : firstCol.header] = this.localDatePipe.transform(data[groupCol.field], 'MM/DD/YYYY')
                    }
                    else if (groupCol.dataType == 'number2dp') {
                        groupObj[isPDF ? firstCol.field : firstCol.header] = data[groupCol.field]?.toFixed(2) ?? data[groupCol.field];
                    }
                    else if (groupCol.dataType == 'currencySymbol') {
                        groupObj[isPDF ? firstCol.field : firstCol.header] = this.currencySymbolPipe.transform(data[groupCol.field], 'number2dp') ?? data[groupCol.field];
                    }
                    else if (groupCol.dataType == 'percentageSymbol') {
                        groupObj[isPDF ? firstCol.field : firstCol.header] = this.percentageSymbolPipe.transform(data[groupCol.field], 'number2dp') ?? data[groupCol.field];
                    }
                    else if (groupCol.dataType == 'timespan') {
                        groupObj[isPDF ? firstCol.field : firstCol.header] = this.timeConvertPipe.transform(data[groupCol.field]) ?? data[groupCol.field];
                    }
                    else {
                        groupObj[isPDF ? firstCol.field : firstCol.header] = data[groupCol.field];
                    }
                    dataResult.push(groupObj);
                    groupColValue = data[groupCol.field];
                }
            }
            //#endregion
            dataResult.push(obj);
        }

        //Push Total Row at last
        if (this.reportTotalRow != null && (this.selectedWindow == ReportsInventoryNames.accountsReceivable
            || this.selectedWindow == ReportsInventoryNames.accountsPayable
            || this.selectedWindow == ReportsInventoryNames.profitByRep
            || this.selectedWindow == ReportsInventoryNames.profitByCustomer
            || this.selectedWindow == ReportsInventoryNames.invoiceByCustomer
            || this.selectedWindow == ReportsInventoryNames.invoiceByRep
            || this.selectedWindow == ReportsInventoryNames.inventoryValuationDetail
            || this.selectedWindow == ReportsInventoryNames.inventoryValuationSummary
            || this.selectedWindow == ReportsInventoryNames.inventoryAging)) {
            const firstCol = cols[0];
            let obj = {};
            for (let col of cols) {
                if (firstCol.field != col.field) {
                    if (col.dataType == 'number2dp' || col.dataType == 'number') {
                        if (isDetailsPrint) {
                            obj[isPDF ? col.field : col.header] = this.reportDetailsTotalRow[col.field]?.toFixed(2) ?? this.reportDetailsTotalRow[col.field];
                        }
                        else if (this.selectedWindow == ReportsInventoryNames.inventoryAging) {
                            obj[isPDF ? col.field : col.header] = this.reportTotalRow[col.field] ?? this.reportTotalRow[col.field];
                        }
                        else {
                            obj[isPDF ? col.field : col.header] = this.reportTotalRow[col.field]?.toFixed(2) ?? this.reportTotalRow[col.field];
                        }
                    }
                    else if (col.dataType == 'currencySymbol') {
                        if (isDetailsPrint) {
                            obj[isPDF ? col.field : col.header] = this.currencySymbolPipe.transform(this.reportDetailsTotalRow[col.field] ?? 0, 'number2dp') ?? this.reportDetailsTotalRow[col.field];
                        }
                        else {
                            obj[isPDF ? col.field : col.header] = this.currencySymbolPipe.transform(this.reportTotalRow[col.field] ?? 0, 'number2dp') ?? this.reportTotalRow[col.field];
                        }
                    }
                    else if (col.dataType == 'percentageSymbol') {
                        if (isDetailsPrint) {
                            obj[isPDF ? col.field : col.header] = this.percentageSymbolPipe.transform((this.reportDetailsTotalRow[col.field] == '' ? 0 : this.reportDetailsTotalRow[col.field]) ?? 0, 'number2dp') ?? this.reportDetailsTotalRow[col.field];
                        }
                        else {
                            obj[isPDF ? col.field : col.header] = this.percentageSymbolPipe.transform((this.reportTotalRow[col.field] == '' ? 0 : this.reportTotalRow[col.field]) ?? 0, 'number2dp') ?? this.reportTotalRow[col.field];
                        }
                    }
                    else {
                        obj[isPDF ? col.field : col.header] = '';
                    }
                }
                else {
                    obj[isPDF ? col.field : col.header] = 'Total';
                }
            }
            dataResult.push(obj);
        }
        return dataResult;
    }

    setPDFColumns(cols: IReportsColumnModel[]): any[] {
        let pdfcolumns: any[] = [];
        cols?.map(col => {
            pdfcolumns.push({ id: col.id, dataKey: col.field, header: col.header, field: col.field });
        });
        return pdfcolumns;
    }

    //table row details Print/Export
    onTableRowDetailsExportClick(type: 'print' | 'PDF' | 'XLSX') {
        this.getTotalOfDetailsTable();
        let detailsGroupCol = this.detailsCols?.find(x => x.field == this.detailsGroupTypeColName) ?? { id: 1, field: this.detailsGroupTypeColName, header: this.detailsGroupTypeColName, dataType: 'string' };
        if (type == 'print') {
            this.pdfInventoryReport(this.reportRowDetails, this.detailsCols, detailsGroupCol, this.selectedWindow, this.detailsHeader, true, true);
        }
        else if (type == 'XLSX') {
            this.excelExportInventoryReport(this.reportRowDetails, this.detailsCols, detailsGroupCol, this.selectedWindow, this.detailsHeader, "XLSX", true);
        }
        else if (type == 'PDF') {
            this.pdfInventoryReport(this.reportRowDetails, this.detailsCols, detailsGroupCol, this.selectedWindow, this.detailsHeader, false, true);
        }
    }
    //#endregion
}
